import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { clearDynamicSection, submitDynamicSection } from '../actions/dynamics';
import DynamicSection from '../components/dynamic-section';
export default connect(state => ({
  submittedSection: state.dynamics.submittedSection,
  countries: state.countries.fetch
}), dispatch => bindActionCreators({
  submitDynamicSection,
  clearDynamicSection
}, dispatch))(DynamicSection);